import { render } from "./CustomMenuItem.vue?vue&type=template&id=0f493b7a"
import script from "./CustomMenuItem.vue?vue&type=script&lang=js"
export * from "./CustomMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__